import styled from 'styled-components';

export const Logo = styled.img`
  height: 50px;
  width: 50px;
`;
